import {
  type TypeBackground,
  Box,
  Container,
  Grid,
  Typography,
} from "@mui/material";

import {
  ServiceHeroImg as Img,
  ServiceHeroImgWrapper as Wrapper,
  ServiceHeroSection as Section,
} from "./styled";

interface ServiceHeroBannerProps {
  backgroundColor?: keyof TypeBackground;
  image: {
    src: string;
    alt: string;
    decorationRight?: boolean;
    decorationSecondary?: boolean;
  };
  heading: string;
  subheading: string;
  cta: React.ReactElement;
  subheadingComponent?: "h2" | "h1" | "span";
  headingComponent?: "h2" | "h1" | "span";
}

export const ServiceHeroBanner: React.FC<ServiceHeroBannerProps> = ({
  backgroundColor = "rose",
  cta,
  heading,
  image: { src, alt, decorationRight = false, decorationSecondary = false },
  subheading,
  subheadingComponent = "h2",
  headingComponent = "h1",
}) => (
  <Section backgroundColor={backgroundColor}>
    <Container>
      <Grid container pt={16}>
        <Grid
          item
          xs={12}
          md={7}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Box>
            <Typography
              variant="overline"
              component={headingComponent}
              color="secondary.light"
              gutterBottom
            >
              {subheading}
            </Typography>
            <Typography
              variant="h1"
              component={subheadingComponent}
              color="secondary"
              gutterBottom
            >
              {heading}
            </Typography>
          </Box>
          <Box py={8}>{cta}</Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={5}
          py={2}
          display="flex"
          justifyContent="center"
          alignContent="middle"
        >
          <Wrapper
            housePosition={decorationRight ? "right" : "left"}
            color={decorationSecondary ? "secondary" : "primary"}
          >
            <Img src={src} alt={alt} sx={{ borderRadius: 2 }}></Img>
          </Wrapper>
        </Grid>
      </Grid>
    </Container>
  </Section>
);
